<template>
  <div v-if="bankDetails.bank" class="ifsc-details">
    <div class="row">
      <b>Bank Name</b>:
      <span>{{bankDetails.bank}}</span>
    </div>
    <div class="row">
      <b>Branch Name</b>:
      <span>{{bankDetails.branch}}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'IfscDetails',
  props: {
    bankDetails: Object
  }
}
</script>

<style scoped lang="scss">
  @import '@/assets/scss/mixins.scss';

  .ifsc-details {
    @include custom-flex(null, flex-end, column);

    .row {
      display: flex;
      font-size: 13px;

      b {
        margin-right: 5px;
        color: $secondary;
        font-weight: 600;
        white-space: nowrap;
      }
      span {
        margin-left: 5px;
        color: $primary;
        font-weight: 500;
        text-align: right;
      }
    }
  }
</style>
